// Remove this eslint comment when replace-typography-css-with-tokens-for-chronos is complete
// We should only have primitives and xcss in this file once cleaned up
import React, { type ReactNode } from 'react';
import Heading from '@atlaskit/heading';
import { Flex, Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import { ContentLegacy, MessagesLegacy, TitleLegacy } from './styled';

export const DEFAULT_CONTENT_WIDTH = 500;
export const DEFAULT_IMAGE_WIDTH_OLD = 221;
export const DEFAULT_IMAGE_WIDTH = 235;
export const DEFAULT_IMAGE_HEIGHT = 138;

export const LARGE_IMAGE_WIDTH = 344;
export const LARGE_IMAGE_HEIGHT = 167;

interface ComponentWithChildren {
	children: ReactNode;
}

const ContentNew: React.FC<ComponentWithChildren> = ({ children }) => (
	<Flex direction="column" justifyContent="start" alignItems="center" xcss={ContentStyles}>
		{children}
	</Flex>
);

// On clean up of replace-typography-css-with-tokens-for-chronos, replace Content with ContentNew
// remove ContentLegacy
export const Content: React.FC<ComponentWithChildren> = ({ children }) => {
	const Component = componentWithFG(
		'replace-typography-css-with-tokens-for-chronos',
		ContentNew,
		ContentLegacy,
	);
	return <Component>{children}</Component>;
};

const MessagesNew: React.FC<ComponentWithChildren> = ({ children }) => (
	<Box xcss={MessagesStyles}>{children}</Box>
);

// On clean up of replace-typography-css-with-tokens-for-chronos, replace Messages with MessagesNew
// remove MessagestLegacy
export const Messages: React.FC<ComponentWithChildren> = ({ children }) => {
	const Component = componentWithFG(
		'replace-typography-css-with-tokens-for-chronos',
		MessagesNew,
		MessagesLegacy,
	);
	return <Component>{children}</Component>;
};

const TitleNew: React.FC<ComponentWithChildren> = ({ children }) => (
	<Heading size="large">
		<Box xcss={TitleComponentStyle}>{children}</Box>
	</Heading>
);

export const Title = componentWithFG(
	'replace-typography-css-with-tokens-for-chronos',
	TitleNew,
	TitleLegacy,
);

const ContentStyles = xcss({
	width: `${DEFAULT_CONTENT_WIDTH}px`,
});

const MessagesStyles = xcss({
	font: token('font.body'),
	textAlign: 'center',
	marginTop: 'space.250',
	marginBottom: 'space.250',
});

const TitleComponentStyle = xcss({
	marginTop: 'space.500',
	textAlign: 'center',
});
